import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useRouter } from 'next/router';
import { getUrlParameter } from '@portal-internet/core';
import { useFetch } from 'components/REDL/utils/fetch';
import { REDLLayouts } from 'components/REDL/utils/constants';
import { useDelivertyUser } from 'hooks/useDelivertyUser';

export const useRedlLayout = (refetch = true) => {
    const router = useRouter();
    const pathname = router.pathname;
    const node = getUrlParameter(router.asPath, 'node');
    const [layout, setLayout] = useState(getUrlParameter(router.asPath, 'layoutpeek'));
    const [layoutName, setLayoutName] = useState(null);

    const { fetchMethod, lastRefreshTime } = useFetch();

    const urlParams = new URLSearchParams(window.location.search);
    const isDelivertyBeta = urlParams.get('dty-beta') === 'true';
    const prefixApi = isDelivertyBeta ? window.jitConfig.apiDELIVERTYBeta : window.jitConfig.apiDELIVERTY;

    const { userData } = useDelivertyUser();

    const { data } = useQuery(
        ['redl-layouts', lastRefreshTime, node],
        () =>
            fetchMethod({
                method: 'GET',
                url: prefixApi + REDLLayouts.replace('{node}', node)
            }),
        {
            enabled: Boolean(userData?.token) && refetch && Boolean(node)
        }
    );

    useEffect(() => {
        if (data) {
            if (data?.principal?.path === layout) {
                setLayoutName(data.principal.nom);
            } else if (data?.secundaris?.length > 0) {
                const foundLayout = data.secundaris.find((item) => item.path === layout);
                setLayoutName(foundLayout ? foundLayout.nom : null);
            } else {
                setLayoutName(null);
            }
        }
    }, [data, layout]);

    return {
        pathname,
        node,
        layout,
        layoutName,
        setLayout,
        data
    };
};
